import { Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import SimulatorFormPortfolio from './SimulatorFormPortfolio';

const SimulatorRendersPortfolio = ({
  formData,
  setSend,
  setFormData,
  setDataSimulation,
  dataChart,
  setFormDataAndPersist,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { profilePortfolio } = dataChart;

  const yearsToMonths = {
    '6 meses': 6,
    '1 año': 12,
    '2 años': 24,
    '3 años': 36,
    '5 años': 60,
  };

  const handleSubmit = async (values, riskPortfolio) => {
    try {
      // Persistir el primer formulario (investmentInitial) vía helper del contexto si existe
      if (setFormDataAndPersist) {
        await setFormDataAndPersist(values);
      } else {
        // fallback: escribir manualmente la key 'investmentInitial'
        try {
          setFormData(values);
          localStorage.setItem(
            'investmentInitial',
            JSON.stringify({
              initialInvestment: values.initialInvestment ?? '',
              monthlyInvestment: values.monthlyInvestment ?? '',
              months: values.months ?? '1 año',
            }),
          );
        } catch (e) {
          console.error('Error writing investmentInitial fallback', e);
        }
      }

      // Guardar los valores específicos del formulario 1 para la vista result del portfolio
      try {
        localStorage.setItem('portfolioSimulationData', JSON.stringify(values));
      } catch (e) {
        console.error('Error writing portfolioSimulationData', e);
      }

      setFormData(values);
      setDataSimulation({
        ...values,
        initialInvestment: Number.parseInt(values.initialInvestment?.replace(/\D/g, '')),
        monthlyInvestment: Number.parseInt(values.monthlyInvestment?.replace(/\D/g, ''))
          ? Number.parseInt(values.monthlyInvestment?.replace(/\D/g, ''))
          : 0,
        months: yearsToMonths[values.months],
        portfolioName: riskPortfolio?.replace(/\sCLP$/, ''),
      });

      setSend(true);
      navigate(`/simulator/portfolio/result/${id}`);
    } catch (err) {
      console.error('handleSubmit portfolio error:', err);
    }
  };

  return (
    <>
      <Stack
        sx={{
          position: 'relative',
          margin: '0 auto',
          top: { md: 0, xs: '20px' },
          width: '90%',
        }}
        justifyContent={'center'}
        alignItems={'center'}>
        <SimulatorFormPortfolio
          handleSubmit={handleSubmit}
          formData={formData}
          riskPortfolio={profilePortfolio}
        />
      </Stack>
    </>
  );
};

export default SimulatorRendersPortfolio;
